import { LinuxIcon, MacOSIcon, MobileIcon, MonitorIcon, WindowsIcon } from '#assets/ReactSvg.ts';
import type { OSGroup } from '#dn-types/downloads.ts';
import { UnreachableCodeError } from '#util/assert-unreachable.ts';
import styles from './OSIcon.module.css';

type Props = { os: OSGroup };

// Decorative by design: every call site names the OS in adjacent text, so the icon is hidden from
// the accessibility tree rather than announced as a nameless graphic.
export function OSIcon({ os }: Props) {
  switch (os) {
    case 'Linux':
      return <LinuxIcon className={styles.OSIcon} aria-hidden="true" />;
    case 'macOS':
      return <MacOSIcon className={styles.OSIcon} aria-hidden="true" />;
    case 'Windows':
      return <WindowsIcon className={styles.OSIcon} aria-hidden="true" />;
    case 'Mobile':
      return <MobileIcon className={styles.OSIcon} aria-hidden="true" />;
    case 'Other':
      return <MonitorIcon className={styles.OSIcon} aria-hidden="true" />;
    default:
      throw new UnreachableCodeError(os, 'Unknown os passed');
  }
}
